import React, { useCallback, useRef } from 'react';
import { useEventListener } from '@24i/player-utils-react';
import { usePlayerUIContext } from '@24i/player-ui';
import { VolumeSlider } from './components/VolumeSlider';
import { VolumeRocker as VolumeRockerContainer, HoverArea } from './styled';
export const VolumeRocker = ({ playerInstance, className, show, hide, setGestureInProgress, isGestureInProgress, muted, volume, styles, showHoverArea = false, }) => {
    const sliderDomContainerRef = useRef(null);
    const { state: { isVolumeOpened }, } = usePlayerUIContext();
    const getAndReportVolume = useCallback(({ clientY }) => {
        const sliderDomContainer = sliderDomContainerRef.current;
        if (!sliderDomContainer)
            return;
        const { top, height } = sliderDomContainer.getBoundingClientRect();
        const slideValue = clientY - top;
        let volumeValue = 1 - slideValue / height;
        volumeValue = Math.max(0, Math.min(1, volumeValue));
        playerInstance.volume = Number.isNaN(volumeValue) ? playerInstance.volume : volumeValue;
    }, [sliderDomContainerRef, playerInstance]);
    const onMouseDown = useCallback((event) => {
        getAndReportVolume(event);
        setGestureInProgress(true);
        event.preventDefault();
        event.stopPropagation();
    }, [getAndReportVolume, setGestureInProgress]);
    const onMouseMove = useCallback((event) => {
        if (isGestureInProgress) {
            event.preventDefault();
            event.stopPropagation();
            getAndReportVolume(event);
        }
    }, [isGestureInProgress, getAndReportVolume]);
    const onMouseUp = useCallback((event) => {
        if (isGestureInProgress) {
            event.preventDefault();
            event.stopPropagation();
        }
    }, [isGestureInProgress]);
    const onClick = useCallback((event) => {
        if (isGestureInProgress) {
            event.preventDefault();
            event.stopPropagation();
            setGestureInProgress(false);
        }
    }, [isGestureInProgress, setGestureInProgress]);
    useEventListener('mousemove', onMouseMove, window);
    useEventListener('mouseup', onMouseUp, window);
    useEventListener('click', onClick, window);
    return (React.createElement(HoverArea, { isVolumeOpened: isVolumeOpened, showHoverArea: showHoverArea, onMouseEnter: show, onMouseLeave: hide, "data-test": "HoverArea" },
        React.createElement(VolumeRockerContainer, { style: styles.container, className: `VolumeRocker ${className}`, "data-test": "VolumeRocker-Inner", ref: sliderDomContainerRef, onMouseDown: onMouseDown, onMouseMove: onMouseMove, onClick: onClick },
            React.createElement(VolumeSlider, { styles: styles.slider, playerInstance: playerInstance, volume: volume, muted: muted }))));
};
VolumeRocker.defaultProps = {
    className: '',
    styles: {
        container: null,
        slider: {},
    },
    showHoverArea: false,
};
//# sourceMappingURL=index.js.map